<footer
  *ngIf="showFooter"
  class="l_flexbar border-top bg-color-white guts-p-full-2 is_fixed is_fixed--bottom is_fixed--full-page"
>
  <div class="l_flex-grow">
    <button
      df-button
      dfButtonType="clear"
      (click)="discardChanges()"
      data-dgat="pageSaveFooter-804"
      [ngClass]="{ 'pl-80': useApollo }"
    >
      {{ i18n.Core_Cancel }}
    </button>
  </div>
  <div>
    <button
      df-button
      [disabled]="saveDisabled"
      [class.is_disabled]="saveDisabled || isSubmitting"
      dfButtonType="primary"
      (click)="saveChanges()"
      [attr.aria-label]="isSubmitting ? i18n.Core_Loading : ''"
      [attr.aria-disabled]="isSubmitting"
      type="submit"
      data-dgat="pageSaveFooter-25e"
    >
      <df-spinner-button [isSpinning]="isSubmitting">
        {{ i18n.Core_SaveChanges }}
      </df-spinner-button>
    </button>
  </div>
</footer>
